import Sortable from 'sortablejs';
import Rails from '@rails/ujs';

document.addEventListener('DOMContentLoaded', () => {
  if ($('.sortable-items').length > 0) {
    let el = document.querySelector('.sortable-items')
    let sortBtn = document.querySelector('.sortable-btn')
    let sortable = Sortable.create(el, {
      disabled: true,
      animation: 150,
      onEnd: event => {
        let id = event.item.dataset.item.split('_').pop(); 
        let data = new FormData();
        data.append("id", id);
        data.append("to", event.newIndex);

        Rails.ajax({
          url: event.item.dataset.url, 
          type: 'PUT', 
          data: data,
          success: resp => {
          }, 
          error: err => {
          }
        })
      }
    })
    sortBtn.onclick = function () {
      let state = sortable.option("disabled"); // get
      sortable.option("disabled", !state); // set
      sortBtn.innerHTML = state ? '結束排序' : '點擊開始排序';
      // document.querySelectorA('.items').classList.toggle('active')
      document.querySelector('.search-form').classList.toggle('invisible')
      $('.sortable-items .items').toggleClass('active')
      $('th a').toggleClass('href-disabled')
    };
  };
  
  
})